const FARM_PLOTS_RESPONSE = {
  Farms: 'Farms',
  TokenError: 'TokenError',
};

export default FARM_PLOTS_RESPONSE;
